/*
 * @author: liaosir
 * @description: OBKoro1
 */
/**
 * @author: liaosir
 * @description: 根据入参warehousecode返回对应的仓库名
 */
/**
 * @param warehousecode
 * @returns string
 * @example tranformWareHouse('CNDGMA');
 */

interface Options {
  valueName: string;
  labelName: string;
}

const transformWareHouse = (warehousecode: string, options: Options = { valueName: 'code', labelName: 'name' }) => {
  const str: string = window.localStorage.getItem('wareMenuList') || window.localStorage.getItem('wareMenu') || '';
  if (!str) return '';
  const wareHouseList: [] = JSON.parse(str);
  const el = wareHouseList.find(
    (e: string) =>
      e[options.valueName] === warehousecode ||
      e[options.valueName]?.toLowerCase() === warehousecode ||
      e[options.valueName]?.toUpperCase() === warehousecode,
  );
  return el ? el[options.labelName] : warehousecode;
};

export { transformWareHouse };
